import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AlertService {
    httpClient: any;
    constructor(private http: HttpClient) {}

    // Get Alert List
    getAlerts(filters?) {
        let params = new HttpParams();
        
        if(filters) {
            if (filters.read !== undefined && filters.read !== null) {
                params = params.set('read', filters.read);
            }
            if (filters.page !== undefined && filters.page !== null) {
                params = params.set('page', filters.page);
            }
            const locationId = filters.location_id || filters.dealer_location_id;
            if (locationId && locationId !== 'all') {
                params = params.set('location_id', locationId);
            }
            const assigneeId = filters.assignee_id || filters.user_id;
            if (assigneeId && assigneeId !== 'all') {
                params = params.set('assignee_id', assigneeId);
            }
            if (filters.missed_calls !== undefined && filters.missed_calls !== null) {
                params = params.set('missed_calls', filters.missed_calls);
            }
            const alertType = filters.alert_type || filters.unread_type;
            if (alertType && alertType !== 'all') {
                params = params.set('alert_type', alertType);
                if (alertType === 'missed_calls') {
                    params = params.set('missed_calls', 1);
                }
            }
        } else {
            params = params.set('read', 0);
        }
        
        return this.http.get<Array<Object>>(
            `${environment.api_url}/alerts`, {
                params: params
            }
        );
    }

    getDealerLocations() {
        return this.http.get<Object>(`${environment.api_url}/dealer/locations`);
    }

    getAlertAssignees() {
        return this.http.get<Object>(`${environment.api_url}/alerts/assignees`);
    }

    markAlertsRead(filters?) {
        return this.http.post<Object>(
            `${environment.api_url}/alerts/read`,
            filters || {}
        );
    }

    // Set Alert Status
    setAlertStatus(id) {
        return this.http.post<Object>(
            `${environment.api_url}/alert/${id}/read`, {}
        );
    }
    updateConversationTimestamp(id:number){
        return this.http.post<Object>(`${environment.api_url}/conversation/update_timestamp/${id}`, {});
    }
}
